<template>
  <div class="AssetsManagement">
    <div id="container">
      <app-header :now=5></app-header>
      <div class="container_box"  style="padding: 0px">
        <router-view></router-view>
        <div id="left_menu">
          <div class="logo">
            <img src="/static/img/logo.png"/>
            <span>智达云服务平台</span>
          </div>
        </div>
<!--        <div id="map"></div>-->
        <div class="AssetsManagementbox">
          <div class="search">
            <div class="search_box">
              <div v-for="item in search" :class='["search_options_box"]'>
                <span>{{item.title}}</span>
                <img src="/static/img/select.png" alt="">
                <select class="select">
                  <option v-for="item2 in item.select" v-bind:value='item2.option'>{{item2.option}}</option>
                </select>
              </div>
              <div class="search_btn_box">
                <button :class='["search_btn","green","icon_btn","clearborder"]'><span class="el-icon-search"></span>查询</button>
              </div>
            </div>
          </div>
          <div class="mag_main">
            <div class="mag_top">
              <div class="mag_style information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="title">设备有效期</div>
              </div>
              <div class="mag_style information_box light_border">
                <div class="border_top_left"></div>
                <div class="border_top_right"></div>
                <div class="border_bottom_left"></div>
                <div class="border_bottom_right"></div>
                <div class="title">资产分布图</div>
              </div>
            </div>
            <div class="mag_bottom information_box light_border">
              <div class="border_top_left"></div>
              <div class="border_top_right"></div>
              <div class="border_bottom_left"></div>
              <div class="border_bottom_right"></div>
              <div class="title">报废提醒信息</div>
              <div class="table_btn">
                <button><span class="icon-8"></span>批量删除</button>
                <button><span class="icon-8"></span>下载</button>
              </div>
              <div class="table_box">

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import HelloWorld from './components/HelloWorld'
  import Header from "./Header";

  export default {
    name: 'AssetsManagement',
    components: {
      "app-header": Header,
    },
    data() {
      return {
        qwerqwre: 0,
        search: [
          {
            title: '项目名称',
            select: [
              {option: "请选择项目"},
              {option: "项目1"},
            ]
          }, {
            title: '设备类型',
            select: [
              {option: "认证设备1"},
              {option: "认证设备2"},
            ]
          },
        ],
      }
    },
    created: function () {
      $(function () {
        let aa = $(".aa"),
          bb = $(".bb");
        aa.css('display', 'block');
        aa.find('ul').hide();
        aa.click(function () {
          $(this).find('ul').slideDown(500);
          $(this).siblings().children("ul").slideUp(500);
        });
        bb.click(function () {
          bb.removeClass('now');
          $(this).addClass('now');
        })
      })
    },
    methods: {
      addClassFun: function (index) {
        this.qwerqwre = index;
      }
    }
  }
</script>

<style scoped>
  #left_menu {
    width: 270px;
    height: 78px;
    position: absolute;
    left: 0;
    top: 0;
    background: #1d4e80
  }

  #left_menu .logo {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #left_menu .logo img {
    margin-right: 10px;
  }

  #left_menu .logo span {
    font-size: 22px;
    color: #ffffff;
    font-weight: bold;
  }
  .container_box {
    background: url("/static/img/bg.jpg") no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: calc(100% - 78px);
    overflow-y: auto;
    box-sizing: border-box;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: transparent; /*滚动条的背景颜色*/
    -webkit-border-radius: 0; /*滚动条的圆角宽度*/
  }

  ::-webkit-scrollbar {
    width: 8px; /*滚动条的宽度*/
    height: 8px; /*滚动条的高度*/
  }

  ::-webkit-scrollbar-thumb { /*垂直滚动条的样式*/
    height: 50px;
    background-color: #95bee5;
    -webkit-border-radius: 4px;
    outline-offset: -2px;
  }

  ::-webkit-scrollbar-thumb:hover { /*滚动条的hover样式*/
    height: 50px;
    background-color: #00f0ff;
    -webkit-border-radius: 4px;
  }
  #map{
    width: 100%;
    height: 100%;
  }
  .AssetsManagement{
    width: 100%;
    height: 100%;
  }
  .AssetsManagementbox{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }
  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }
  .mag_main{
    width: 100%;
    height: calc(100% - 120px);
    padding: 0px 0px 20px;
    box-sizing: border-box;
  }
  .mag_top{
    width: 100%;
    height: 50%;
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
  }
  .mag_bottom{
    width: 100%;
    height: calc(50% - 40px);
    padding: 20px;
    box-sizing: border-box;
  }
  .title{
    font-size: 20px;
    color: #00fafe;
    line-height: 20px;
  }
  .mag_style{
    width: calc(50% - 10px);
    height: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  .light_border {
    box-shadow: 0 0 10px #3494f6 inset;
    border: 1px solid #4b9ffc;
  }
  .information_box {
    position: relative;
    margin-top: 20px;
    float: left;
    background: #0b2f54;
  }
  .border_top_left, .border_top_right, .border_bottom_left, .border_bottom_right {
    width: 26px;
    height: 26px;
    position: absolute;
    background: url("/static/img/border.png") no-repeat center center;
  }

  .border_top_left {
    left: -2px;
    top: -2px;
  }

  .border_top_right {
    right: -2px;
    top: -2px;
    transform: rotate(90deg);
  }

  .border_bottom_left {
    left: -2px;
    bottom: -2px;
    transform: rotate(-90deg);
  }

  .border_bottom_right {
    right: -2px;
    bottom: -2px;
    transform: rotate(180deg);
  }
  .table_btn{
    position: absolute;
    top: 10px;
    right: 20px;
    display: flex;
  }
  .table_btn>button{
    width: 96px;
    height: 32px;
    color: #FFFFFF;
    border: transparent;
    outline: transparent;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 10px;
  }
  .table_btn>button>span{
    margin-right: 5px;
  }
  .table_btn>button:nth-child(1){
    background: #f24d4d;
  }
  .table_btn>button:nth-child(1):active{
    background: #e54242;
  }
  .table_btn>button:nth-child(2){
    background: #21b868;
  }
  .table_btn>button:nth-child(2):active{
    background: #19ac5e;
  }
</style>



// WEBPACK FOOTER //
// src/components/AssetsManagement.vue